module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-46.18a7cf4c.png";